<div class="flex flex-row items-center">
  <label class="input-main-label mt-0">2-Way Communication</label>
  <mat-slide-toggle
    class="main-toggle mr-3"
    (change)="onUpdate($event.checked)"
    [checked]="client()?.twoWayCommunication ?? value()"
    [disabled]="userRole() !== eUserRolesIds.SuperAdmin"
  />
  <img
    class="w-5 h-5"
    alt="help"
    matTooltip="When disabled, the system will restrict outbound communication (e.g., device actions, remote actions, workflows) while still allowing inbound data from devices."
    matTooltipPosition="above"
    src="assets/icons/help.svg"
  >
</div>
